<template>
    <SectionBase v-bind="$attrs" :section="section" :style="[ bgColor ]">
        <AnimationWrapper
            :animation-style="animationSettings?.animationStyle !== 'NONE' ? 'FADE_IN' : null"
        >
            <template #animationContent>
            <div :class="['divider-line', dividerStyle.weight, dividerStyle.text_position, dividerStyle.text_alignment]">
                <div class="line preview"></div>
                <div v-if="dividerStyle.text_position !== 'no_text'"
                     class="text preview"
                     :style="[ bgColor ]"
                >
                    <div :class="['text-container', section.title.style && section.title.style.textStyle ? section.title.style.textStyle : 'default--h2' ]"
                         :style="{color: section.title.style && !section.title.style.textStyle && section.title.style.fontColor ? section.title.style.fontColor : null }"
                         v-html="fixText('title')"
                    >
                    </div>
                </div>
            </div>
            </template>
        </AnimationWrapper>
    </SectionBase>
</template>

<script>
    import SectionBase from "./SectionBase.vue";
    import AnimationWrapper from "../../../common/components/AnimationWrapper.vue";
    import {mapGetters} from "vuex";

    export default {
        name: "DividerLine",
        components: {SectionBase, AnimationWrapper},
        props: ['section'],
        methods: {
            fixText(data) {
                return this.section[data].text
            }
        },
        computed: {
            ...mapGetters("view", ["viewData"]),
            portfolio() {
              return this.viewData.portfolio || this.$store.state.portfolio
            },
            project() {
              return this.viewData.project || this.$store.state.project
            },
            dividerStyle() {
                return this.section.settings ?? this.portfolio.templateSettings.dividerLineSettings
            },
            bgColor() {
                const backgroundColor = this.section.backgroundSettings?.backgroundColor;
                if(backgroundColor) {
                    let bgColor = backgroundColor.startsWith("#")
                        ? backgroundColor
                        : `#${backgroundColor}`;

                    return {'background-color': bgColor};
                } else {
                    return null
                }
            },
            ...mapGetters("design", ["animationSettings"]),
        }
    }
</script>